/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import {
  AbstractControl, NG_VALIDATORS, ValidationErrors, Validator,
} from '@angular/forms';
import { Directive, Input } from '@angular/core';

/**
 * Custom validator that validate the regex pattern for the field.
 */
@Directive({
  selector: '[bulbValidatePattern]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidatePatternDirective,
      multi: true,
    },
  ],
  standalone: false,
})
export class ValidatePatternDirective implements Validator {
  /**
   * To validate with the given pattern.
   */
  @Input() bulbValidatePattern: RegExp;

  /**
   * Validate the field .
   *
   * @param control of the input field.
   * @return validation error/null
   */
  validate(control: AbstractControl): ValidationErrors | null {
    if (control && control.value) {
      if (!this.bulbValidatePattern.test(control.value)) {
        return { invalidPattern: true };
      }
    }
    return null;
  }
}
